import React from 'react';
import PropTypes from 'prop-types';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import BarChartIcon from '@mui/icons-material/BarChart';
import RemoveIcon from '@material-ui/icons/Remove';
import GetAppIcon from '@material-ui/icons/GetApp';
import { IconButton } from '@material-ui/core';
import Collapsable from 'components/Collapsable/Collapsable';
import translations from 'data/translations.json';

class ExpandableTableRow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isCollapsed: !this.props.startOpen
        };
    }

    expand() {
        this.setState({ isCollapsed: false });
    }

    collapse() {
        this.setState({ isCollapsed: true });
    }

    render() {
        const onButtonClick = () => {
            if (this.state.isCollapsed) {
                this.props.onExpand(this);
            }
            this.setState({ isCollapsed: !this.state.isCollapsed });
        };

        if (this.props.mobile) {
            return (
                <>
                    <tr className={this.props.className}>
                        <td className="only-icon-td">
                            <IconButton onClick={onButtonClick} disabled={this.props.isDummyElement} title={this.state.isCollapsed ? translations.expandChart[window.lang] : translations.minimizeChart[window.lang]}>
                                {
                                    this.props.isDummyElement ? <RemoveIcon /> : (this.state.isCollapsed ? (<div> <BarChartIcon style={{ color: "#ba0d14" }} /> <KeyboardArrowDownIcon /></div>) : (<div><BarChartIcon style={{ color: "#ba0d14" }} /> <KeyboardArrowUpIcon /></div>))
                                }
                            </IconButton>
                        </td>
                        <td className="only-icon-td">
                            <a href={this.props.downloadRef} download className="download-icon-a" title={translations.indicatorDownload[window.lang]}><GetAppIcon /></a>
                        </td>
                    </tr>
                    <tr className={this.props.className}>
                        {
                            <Collapsable collapsed={this.state.isCollapsed} colSpan={this.props.expandColSpan}>
                                {this.props.expandData}
                            </Collapsable>
                        }
                    </tr>
                </>
            );
        } else {
            return (
                <>
                    <tr className={this.props.className}>
                        {this.props.children}
                        <td className="only-icon-td">
                            <IconButton onClick={onButtonClick} disabled={this.props.isDummyElement} title={this.state.isCollapsed ? translations.expandChart[window.lang] : translations.minimizeChart[window.lang]}>
                                {
                                    this.props.isDummyElement ? <RemoveIcon /> : (this.state.isCollapsed ? (<div> <BarChartIcon style={{ color: "#ba0d14" }} /> <KeyboardArrowDownIcon /></div>) : (<div><BarChartIcon style={{ color: "#ba0d14" }} /> <KeyboardArrowUpIcon /></div>))
                                }
                            </IconButton>
                        </td>
                        <td className="only-icon-td">
                            <a href={this.props.downloadRef} download className="download-icon-a" title={translations.indicatorDownload[window.lang]}><GetAppIcon /></a>
                        </td>
                    </tr>
                    <tr className={this.props.className}>
                        {
                            <Collapsable collapsed={this.state.isCollapsed} colSpan={this.props.expandColSpan}>
                                {this.props.expandData}
                            </Collapsable>
                        }
                    </tr>
                </>
            );
        }
    }
}

ExpandableTableRow.propTypes = {
    expandData: PropTypes.node,
    onExpand: PropTypes.func.isRequired,
    expandColSpan: PropTypes.number,
    isDummyElement: PropTypes.bool,
    startOpen: PropTypes.bool,
    mobile: PropTypes.bool,
};

ExpandableTableRow.defaultProps = {
    expandData: null,
    expandColSpan: 1,
    isDummyElement: false,
    startOpen: false,
    mobile: false
}

export default ExpandableTableRow;
